import MUIDataTable from "mui-datatables";
import React, { useState, useEffect } from "react";

import LoadingOverlay from "./components/LoadingOverlay";
import { getCommonCellProps, getCommonHeaderProps } from "./components/TableColumnConfig";

const SupportTab = (props) => {
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (!props.data?.supportTickets) return;

        const processed = props.data.supportTickets.map((item) => {
            const out = { ...item };
            Object.keys(out).forEach((key) => {
                if (out[key] === undefined || out[key] === null) out[key] = "-";
            });
            return out;
        });

        setTableData(processed);
    }, [props.data]);

    const columns = [
        {
            name: "company_name",
            label: "Company",
            options: {
                setCellProps: () => getCommonCellProps("200px"),
                setCellHeaderProps: () => getCommonHeaderProps("200px"),
            },
        },
        {
            name: "last_month_tickets",
            label: "Last Month",
            options: {
                setCellProps: () => ({
                    ...getCommonCellProps("120px"),
                    style: {
                        ...getCommonCellProps("120px").style,
                        textAlign: "right",
                        paddingRight: "17px",
                    },
                }),
                setCellHeaderProps: () => getCommonHeaderProps("120px"),
                sortCompare: (order) => (a, b) =>
                    (Number(a.data) - Number(b.data)) * (order === "asc" ? 1 : -1),
            },
        },
        {
            name: "current_month_tickets",
            label: "Current Month",
            options: {
                setCellProps: () => ({
                    ...getCommonCellProps("140px"),
                    style: {
                        ...getCommonCellProps("140px").style,
                        textAlign: "right",
                        paddingRight: "17px",
                    },
                }),
                setCellHeaderProps: () => getCommonHeaderProps("140px"),
                sortCompare: (order) => (a, b) =>
                    (Number(a.data) - Number(b.data)) * (order === "asc" ? 1 : -1),
            },
        },
        {
            name: "ytd_tickets",
            label: "YTD",
            options: {
                setCellProps: () => ({
                    ...getCommonCellProps("100px"),
                    style: {
                        ...getCommonCellProps("100px").style,
                        textAlign: "right",
                        paddingRight: "17px",
                    },
                }),
                setCellHeaderProps: () => getCommonHeaderProps("100px"),
                sortCompare: (order) => (a, b) =>
                    (Number(a.data) - Number(b.data)) * (order === "asc" ? 1 : -1),
            },
        },
        {
            name: "total_tickets",
            label: "Total",
            options: {
                setCellProps: () => ({
                    ...getCommonCellProps("100px"),
                    style: {
                        ...getCommonCellProps("100px").style,
                        textAlign: "right",
                        paddingRight: "17px",
                    },
                }),
                setCellHeaderProps: () => getCommonHeaderProps("100px"),
                sortCompare: (order) => (a, b) =>
                    (Number(a.data) - Number(b.data)) * (order === "asc" ? 1 : -1),
            },
        },
    ];

    const options = {
        responsive: "standard",
        selectableRows: "none",
        searchAlwaysOpen: true,
        storageKey: "supportTable",
        filter: false,
        sort: true,
        sortOrder: { name: "total_tickets", direction: "desc" },
        search: true,
        print: false,
        download: false,
        viewColumns: false,
        columnOrder: null,
        fixedHeader: false,
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 250],
    };

    if (!props.data) {
        return <LoadingOverlay text="Loading support data..." />;
    }

    return (
        <div className="flex w-full flex-col">
            {tableData.length > 0 ? (
                <MUIDataTable
                    data={tableData}
                    columns={columns}
                    options={options}
                    className="ngShadow"
                />
            ) : (
                <h3 className="px-2 pt-8 text-center">No ticket data found.</h3>
            )}
        </div>
    );
};

export default SupportTab;
